export default __webpack_public_path__ + "static/media/college.af480d6f.png";